export function validateEnvVariable(variable?: string): string {
  if (!variable) {
    throw new Error(
      `Environment variable ${variable} is not defined. It is a required variable.`
    );
  }
  return variable;
}
